import { Minus as Minus_kojaro } from './Minus.kojaro';
import { Minus as Minus_phosphor } from './Minus.phosphor';
import { Minus as Minus_zoomg } from './Minus.zoomg';
import { Minus as Minus_zoomit } from './Minus.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return Minus_kojaro;

    case 'zoomg':
      return Minus_zoomg;

    case 'phosphor':
      return Minus_phosphor;

    default:
      return Minus_zoomit;
  }
};

export const Minus = IconRenderer();
